import Yup from '_zari/validation/_yup'

const validationSchema = Yup.object().shape({})

export default validationSchema
